export default "__VITE_ASSET__c993a1f4__"